import React from 'react';
import { View, Text, StyleSheet, Alert } from 'react-native';
import { StackScreenProps } from '@react-navigation/stack';
import { RootStackParamList } from '../navigation/types';
import { QRScanner } from '../components/QRScanner';
import { ChildFriendlyBackground } from '../components/ChildFriendlyBackground';
import { ScanLine } from 'lucide-react-native';

type Props = StackScreenProps<RootStackParamList, 'Scan'>;

export function ScanScreen({ navigation }: Props) {
    const handleScan = (data: string) => {
        console.log('[ScanScreen] Scanned data:', data);
        let classId = data;
        let serverUrl = '';

        try {
            // Attempt to parse as JSON first (modern QR format)
            const parsed = JSON.parse(data);
            if (parsed.classId) {
                console.log('[ScanScreen] Parsed JSON QR:', parsed);
                classId = parsed.classId;
                serverUrl = parsed.serverUrl || '';
            }
        } catch {
            console.log('[ScanScreen] Plain string QR detected');
            // Fallback: Legacy payload is just the plain class ID string
        }

        if (!classId || classId.trim() === '') {
            Alert.alert('Invalid QR Code', 'Could not read a valid Class ID from this code.');
            return;
        }

        navigation.replace('Discovering', { classId, serverUrl });
    };

    const handleCancel = () => {
        if (navigation.canGoBack()) {
            navigation.goBack();
        } else {
            navigation.replace('Home');
        }
    };

    return (
        <ChildFriendlyBackground variant="dark" scrollable={false}>
            <View style={styles.header}>
                <ScanLine size={48} color="#FFFFFF" strokeWidth={2.5} />
                <Text style={styles.headerTitle} allowFontScaling={true} maxFontSizeMultiplier={1.5}>Point your tablet at the teacher's code</Text>
            </View>
            <View style={styles.scannerContainer}>
                <QRScanner onScan={handleScan} onCancel={handleCancel} />
            </View>
        </ChildFriendlyBackground>
    );
}

const styles = StyleSheet.create({
    header: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 16,
        paddingHorizontal: 24,
    },
    headerTitle: {
        fontSize: 20,
        fontWeight: '700',
        color: '#FFFFFF',
        textAlign: 'center',
        marginTop: 12,
        textShadowColor: 'rgba(0, 0, 0, 0.5)',
        textShadowOffset: { width: 0, height: 2 },
        textShadowRadius: 4,
    },
    scannerContainer: {
        flex: 1,
    },
});
